import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import React, { Component, Fragment } from "react";
import ClientCountries from "../../countries/ClientCountries";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import { selectCountry } from "../../../../Redux/actions/sessionActions";

import ShowIcon from "../../../../../static/images/Show.svg";
import UserIcon from "../../../../../static/images/user-icon.svg";
import LockIcon from "../../../../../static/images/lock-icon.svg";
import CloseIcon from "../../../../../static/images/close-icon.svg";
import ErrorIcon from "../../../../../static/images/error-icon.svg";

export class LoginBlock extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {
        username: "",
        key: "",
        country: "",
        formValidation: "RFToken",
      },
      errors: {},
      hidden: true,
    };
  }

  handlerChange(event) {
    event.preventDefault();
    const { user, errors } = this.state;
    user[event.target.name] = event.target.value;

    if (errors[event.target.name] != "") {
      delete errors[event.target.name];
      this.setState({ errors });
    }

    this.setState({ user });
  }

  handlerCountry(event) {
    const { user, errors } = this.state;

    if (errors["country"] != "") {
      delete errors["country"];
      this.setState({ errors });
    }

    this.setState({ user: { ...user, country: event.target.value } });
    this.props.setCountry(event.target.value);
  }

  onClickButton(event) {
    event.preventDefault();

    const { username, key, country } = this.state.user;
    const { errors } = this.state;
    const { t, userType, env } = this.props;

    //Validamos campos vacios
    if (env !== "prd" && userType === "BSC" && country == "") {
      errors["country"] = `${t("login.forms.errors.required")}`;
    }
    if (username == "" && !this.props.onlyPassword) {
      errors["username"] = `${t("login.forms.errors.required")}`;
    }
    if (key == "") {
      errors["key"] = `${t("login.forms.errors.required")}`;
    }

    // Si estamos en producción logueando a un BSC le pasamos los valores por defecto
    this.setState({ errors });

    if (Object.keys(errors).length <= 0) {
      this.props.btnAction(username, key, this.state.user.formValidation);
    }
  }

  clearUsername(event) {
    event.preventDefault();
    const user = this.state.user;
    user.username = "";
    this.setState({ user });
  }

  clearPass(event) {
    event.preventDefault();
    const user = this.state.user;
    user.key = "";
    this.setState({ user, hidden: true });
  }

  closeButton() {
    return this.state.user.username != "" ? (
      <div
        className="button input-w-aux__action clear-user"
        onClick={(event) => this.clearUsername(event)}
      >
        <img
          src={CloseIcon}
          alt={`${this.props.t("general.labels.clear")}`}
        />
      </div>
    ) : null;
  }

  clearPassBtn() {
    return this.state.user.key != "" ? (
      <div
        className="button input-w-aux__action clear-password"
        onClick={(event) => this.clearPass(event)}
      >
        <img
          src={CloseIcon}
          alt={`${this.props.t("general.labels.clear")}`}
        />
      </div>
    ) : null;
  }

  showUserpass() {
    this.setState({ hidden: !this.state.hidden });
  }

  seeButton() {
    return this.state.user.key != "" ? (
      <div
        className="button input-w-aux__action see-password fix-password"
        onClick={() => this.showUserpass()}
      >
        <img
          src={ShowIcon}
          alt={`${this.props.t("general.labels.clear")}`}
        />
      </div>
    ) : null;
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] !== undefined && errors[id] !== "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { t } = this.props;

    return (
      <Fragment>
        {this.props.title && this.props.title != "" && (
          <>
            <h2>{this.props.title}</h2>
          </>
        )}
        <div className="login-form">
          <form
            id="submit-form"
            className="login"
            method="post"
            onSubmit={(event) => this.onClickButton(event)}
          >
            {this.props.env !== "" &&
              this.props.env !== "prd" &&
              this.props.userType === "BSC" && (
                <div className="input-w-aux">
                  <ClientCountries
                    id={`login-country`}
                    onChange={(e) => this.handlerCountry(e)}
                    readOnly={false}
                    className={``}
                  />
                  {this.displayError("country")}
                </div>
              )}

            {!this.props.onlyPassword && (
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={UserIcon}
                  alt={this.props.lblUsername}
                />
                <input
                  id="username"
                  name="username"
                  type="text"
                  className="input input--text input-w-aux__input input--active"
                  autoComplete="off"
                  placeholder={this.props.lblUsername}
                  value={this.state.user.username}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton()}
                {this.displayError("username")}
              </div>
            )}

            <div className="input-w-aux">
              <img
                className="button input-w-aux__icon"
                src={LockIcon}
                alt={this.props.lblUserpass}
              />
              <input
                id="key"
                name="key"
                className="input input--text input-w-aux__input"
                type={this.state.hidden ? "password" : "text"}
                placeholder={this.props.lblUserpass}
                autoComplete="off"
                value={this.state.user.key}
                onChange={(event) => this.handlerChange(event)}
              />
              {this.seeButton()}
              {this.clearPassBtn()}
              {this.displayError("key")}
            </div>

            {this.props.userType !== "BSC" &&
              this.props.env !== undefined &&
              this.props.env !== "" && (
                <React.Fragment>
                  {window.location.pathname === "/clients/login" ||
                  window.location.pathname === "/providers/login" ? (
                    <div>
                      <div className="row justify-content-end text forget">
                        <p>
                          <Link to="/user/reset-password">
                            {`${t("login.forms.links.passwordRecovery")}`}
                          </Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.credentialsLbl")} `}
                          <Link to="/credentials">{`${t(
                            "login.forms.links.credentials"
                          )}`}</Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.registerLbl")} `}
                          <Link to={"/register"}>{`${t(
                            "login.forms.links.register"
                          )}`}</Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {t("login.forms.links.registerProvider")} -{" "}
                          <Link to={"/register/new-provider"}>
                            {t("login.forms.links.credentials")}
                          </Link>
                        </p>
                      </div>
                    </div>
                  ) : window.location.pathname === "/register" ? (
                    <div>
                      <div className="row justify-content-end text forget">
                        <p>
                          <Link to="/user/reset-password">
                            {`${t("login.forms.links.passwordRecovery")}`}
                          </Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.credentialsLbl")} `}
                          <Link to="/credentials">{`${t(
                            "login.forms.links.credentials"
                          )}`}</Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.landingLbl")} `}
                          <Link to="/landing">{`${t(
                            "login.forms.links.landing"
                          )}`}</Link>
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="row justify-content-end text forget">
                        <p>
                          <Link to="/user/reset-password">
                            {`${t("login.forms.links.passwordRecovery")}`}
                          </Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.registerLbl")} `}
                          <Link to={"/register"}>{`${t(
                            "login.forms.links.register"
                          )}`}</Link>
                        </p>
                      </div>
                      <div className="row justify-content-end text">
                        <p>
                          {`${t("login.forms.links.landingLbl")} `}
                          <Link to="/landing">{`${t(
                            "login.forms.links.landing"
                          )}`}</Link>
                        </p>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}
            <div className="row justify-content-end">
              <PrimaryButton>{this.props.lblActionBtn}</PrimaryButton>
              {/* <button type="submit">{this.props.lblActionBtn}</button> */}
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}

LoginBlock.propTypes = {
  title: PropTypes.string,
  lblUsername: PropTypes.string.isRequired,
  lblUserpass: PropTypes.string.isRequired,
  lblActionBtn: PropTypes.string.isRequired,
  btnAction: PropTypes.func.isRequired,
};

export const mapDispatch = (dispatch) => {
  return {
    setCountry: (payload) => dispatch(selectCountry(payload)),
  };
};

export default connect(null, mapDispatch)(withTranslation()(LoginBlock));
